/**
 * Sidebar navigation model for the app shell. Icons are Material Icons ligatures; where
 * the design used a custom glyph with no Material equivalent, fall back to the closest
 * match and revisit if needed.
 *
 * The nav is FLAT: one list, every row a top-level item, all rendered as
 * `styles-menu-header`. There is deliberately no group/child model here — the library's
 * `styles-menu-item` exists for rows nested under an expandable header, and it comes
 * with that job baked in (hidden unless a header tells it to show, and its icon indented
 * 50px to sit under a parent). Reintroducing a group means bringing back the header's
 * `children` QueryList wiring as well; see side-menu.ts.
 */
export interface NavItem {
  label: string;
  icon: string;
  /** In-app destination, navigated with routerLink. Mutually exclusive with `url`. */
  route?: string;
  /**
   * An external destination, opened in a new tab. Mutually exclusive with `route` —
   * the library's menu header navigates with `Router.navigateByUrl`, which cannot
   * leave the app, so these rows are wrapped in a real anchor instead.
   */
  url?: string;
  /**
   * Routes this row highlights as active for. Defaults to its own `route`.
   *
   * Set it to `[]` for a row that must never claim the active state — Home points at
   * the same place as Projects, and without this both rows would light up at once.
   */
  activeRoutes?: string[];
}

export const NAV_ITEMS: NavItem[] = [
  // Home and Projects are deliberately the same destination. Projects owns the active
  // highlight (see `activeRoutes`), so only one row lights up there.
  { label: 'Home', icon: 'home', route: '/projects', activeRoutes: [] },
  { label: 'My Calendar', icon: 'calendar_month', url: 'https://calendar.google.com' },
  { label: 'My Kanban', icon: 'view_kanban', url: 'https://kanban.brafton.com' },
  { label: 'Projects', icon: 'dataset', route: '/projects' },
  { label: 'Atlas', icon: 'public', url: 'https://atlas.brafton.com' },
];
